Vendd.Scripts.load(function () {
    var $wrapper = $('.x-category-list');

    if ($wrapper.length <= 0)
        return;

    var $categoryItems = $('ul li', $wrapper);
    var $moreButton = $('.js-show-categories', $wrapper);
    var categoryItemsShow = false;
    var scrollTopAmount;
    var speedPerThousandPixels = 500, maxSpeed = 1500, minSpeed = 300;

    initButton();
    $(window).resize(initButton);

    $moreButton.on('click', function () {
        if (!categoryItemsShow) {
            $categoryItems.addClass('expanded');
            $(this).find('.more').hide();
            $(this).find('.less').show();
            $moreButton.find('.icon').removeClass('icon-plus').addClass('icon-minus');
            categoryItemsShow = true;
        } else {
            $categoryItems.removeClass('expanded');
            $moreButton.find('.icon').removeClass('icon-minus').addClass('icon-plus');
            $(this).find('.more').show();
            $(this).find('.less').hide();

            scrollTopAmount = $wrapper.offset().top - $('.header-region .region-area-two').height() - $('.header-region .region-area-three').innerHeight();
            var speed = parseInt(Math.abs(scrollTopAmount * speedPerThousandPixels / 1000), 10);
            if (speed > maxSpeed) speed = maxSpeed;
            if (speed < minSpeed) speed = minSpeed;

            $('html, body').animate({ scrollTop: scrollTopAmount }, speed);

            categoryItemsShow = false;
        }
    });
    function initButton() {

        if ($(window).outerWidth() < 1200 && $(window).outerWidth() > 480) {
            if ($categoryItems.length > 6) {
                $moreButton.removeClass('hidden');
            } else {
                $moreButton.addClass('hidden');
            }
        } else if ($(window).outerWidth() < 480) {
            if ($categoryItems.length > 4) {
                $moreButton.removeClass('hidden');
            } else {
               $moreButton.addClass('hidden');
            }
        } else {
            if ($categoryItems.length > 12) {
                $moreButton.removeClass('hidden');
            } else {
                $moreButton.addClass('hidden');
            }
        };
    }
});